import reduce from "lodash/reduce";
import pick from "lodash/pick";
import type { Content } from "@prismicio/client";
import * as prismicH from "@prismicio/helpers";

export const extractSocialsLinksProps = (settings: Content.SettingsDocument) =>
  reduce(
    pick(settings.data, [
      "tiktok",
      "facebook",
      "instagram",
      "pinterest",
      "twitter",
      "youtube",
      "ginned_blog",
      "linkedin",
    ]),
    (res, value, key) => ({ ...res, [key]: prismicH.asLink(value) }),
    {},
  );
